import { Outlet } from "react-router-dom";
import { DesignPackageConfiguratorProvider } from "./DesignPackageConfiguratorContext";

/**
 * Design package configurator context for the data router.
 *
 * Role: data router pathless/context layout. Provides configurator state and renders `<Outlet />`
 * for nested detail/search/add-product/index leaves registered in `designPackages.ts`.
 */
export function DesignPackageConfiguratorLayout() {
  return (
    <DesignPackageConfiguratorProvider>
      <Outlet />
    </DesignPackageConfiguratorProvider>
  );
}
